import { SIGN_OUT } from 'Global/Stores/auth'

import { updatePrimaryPicture } from 'Global/Helpers/rugHelpers'
import { updateReservations } from 'Global/Helpers/reservationHelpers'

import {
  PICTURE_DESIGNER_UPLOAD_FULFILLED,
  PICTURE_DESIGNER_UPLOAD_PENDING,
  PICTURE_DESIGNER_UPLOAD_REJECTED,
  PICTURE_PRIMARY_SET_FULFILLED,
  REQUEST_CREATE_FULFILLED,
  REQUEST_DELETE_FULFILLED,
  RUG_MASTERPIECE_TOGGLE_FULFILLED,
  RUG_MFD_TOGGLE_FULFILLED,
} from 'Global/Stores/rugs'

import { RESERVATION_CREATE_FULFILLED, RESERVATION_DELETE_FULFILLED, RESERVATION_EDIT_FULFILLED } from 'Global/Stores/reservations'

const RUG_GET = 'API|RUG/GET'
const RUG_GET_FULFILLED = `FULFILLED_${RUG_GET}`
const RUG_GET_PENDING = `PENDING_${RUG_GET}`
const RUG_GET_REJECTED = `REJECTED_${RUG_GET}`

/**
 * GET request to the API to get a specific rug.
 * @param {number} id - Rug's id.
 * @returns {object} Action object.
 */
export const getRug = id => ({
  meta: { url: `/api/v1/rugs/${id}` },
  type: RUG_GET,
})

const initialState = {
  error: false,
  pending: true, // I'm not sure if this is a good idea.
  pictureError: -1,
  picturePending: -1,
  rug: {},
}

const reducer = (state = initialState, action) => {
  const { meta, payload, type } = action

  switch (type) {
    case PICTURE_DESIGNER_UPLOAD_FULFILLED: {
      return {
        ...state,
        rug: payload.data,
        picturePending: -1,
        pictureError: -1,
      }
    }

    case PICTURE_DESIGNER_UPLOAD_PENDING: {
      return {
        ...state,
        picturePending: meta.picture,
        pictureError: -1,
      }
    }

    case PICTURE_DESIGNER_UPLOAD_REJECTED: {
      return {
        ...state,
        picturePending: -1,
        pictureError: meta.picture,
      }
    }

    case PICTURE_PRIMARY_SET_FULFILLED:
      return {
        ...state,
        rug: {
          ...state.rug,
          pictures: updatePrimaryPicture(meta.picture, state.rug.pictures),
        },
      }

    case REQUEST_CREATE_FULFILLED:
      if (payload.data.rug !== state.rug.id) {
        return state
      }

      return {
        ...state,
        rug: {
          ...state.rug,
          requests: (state.rug.requests || []).concat(payload.data),
        },
      }

    case REQUEST_DELETE_FULFILLED:
      if (payload.data.rug !== state.rug.id) {
        return state
      }

      return {
        ...state,
        rug: {
          ...state.rug,
          requests: (state.rug.requests || []).filter(r => r.id !== payload.data.id),
        },
      }

    case RESERVATION_CREATE_FULFILLED:
      if (payload.data.rug !== state.rug.id) {
        return state
      }

      return {
        ...state,
        rug: {
          ...state.rug,
          reservations: [...state.rug.reservations, payload.data],
        },
      }

    case RESERVATION_DELETE_FULFILLED:
      return {
        ...state,
        rug: {
          ...state.rug,
          reservations: updateReservations(state.rug.reservations, payload.data),
        },
      }

    case RESERVATION_EDIT_FULFILLED:
      return {
        ...state,
        rug: {
          ...state.rug,
          reservations: updateReservations(state.rug.reservations, payload.data),
        },
      }

    case RUG_GET_FULFILLED:
      return {
        ...state,
        error: false,
        pending: false,
        rug: payload.data,
      }

    case RUG_GET_PENDING:
      return {
        ...state,
        error: false,
        pending: true,
      }

    case RUG_GET_REJECTED:
      return {
        ...state,
        error: true,
        pending: false,
      }

    case RUG_MASTERPIECE_TOGGLE_FULFILLED:
      if (payload.data !== state.rug.id) {
        return state
      }

      return {
        ...state,
        rug: {
          ...state.rug,
          isMasterpiece: !state.rug.isMasterpiece,
        },
      }

    case RUG_MFD_TOGGLE_FULFILLED:
      if (payload.data !== state.rug.id) {
        return state
      }

      return {
        ...state,
        rug: {
          ...state.rug,
          markedForDesigners: !state.rug.markedForDesigners,
        },
      }

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
